import background from './background.mjs'
import {
  imgproxySettings,
  mobileImgproxySettings,
  resolvePaceOptionsFromSKU as resolveOptionsFromSKU,
  getSKUWithoutPrefix,
  stripMatteOrInfinitePrefix,
} from './shared.mjs'

export const frame = {
  id: 'frame',
  name: 'Frame',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    Fclear: {
      pathTemplate: 'gs://sg360/220520/Airas/af/af_Fclear_{nnn}.png',
    },
    clear: {
      pathTemplate: 'gs://sg360/220520/Airas/af/af_Fclear_{nnn}.png',
    },
    grey: {
      pathTemplate: 'gs://sg360/220520/Airas/af/af_Idarkgrey_{nnn}.png',
    },
    black: {
      pathTemplate: 'gs://sg360/220520/Airas/af/af_Iblack_{nnn}.png',
    },
    navy: {
      pathTemplate: 'gs://sg360/220520/Airas/af/af_Inavy_{nnn}.png',
    },
    mint: {
      pathTemplate: 'gs://sg360/220520/Airas/af/af_Mmint_{nnn}.png',
    },
    pink: {
      pathTemplate: 'gs://sg360/220520/Airas/af/af_Mpink_{nnn}.png',
    },
    stone: {
      pathTemplate: 'gs://sg360/220520/Airas/af/af_Mstone_{nnn}.png',
    },
    white: {
      pathTemplate: 'gs://sg360/220520/Airas/af/af_Mwhite_{nnn}.png',
    },
    slateblue: {
      pathTemplate: 'gs://sg360/240409/slateblue/af_Islateblue_{nnn}.png',
    },
  },
}

export const bottom = {
  id: 'bottom',
  name: 'Bottom',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    none: {
      disabled: true,
    },
    Fclear: {
      pathTemplate: 'gs://sg360/220520/Airas/ab/ab_Fclear_{nnn}.png',
    },
    clear: {
      pathTemplate: 'gs://sg360/220520/Airas/ab/ab_Fclear_{nnn}.png',
    },
    grey: {
      pathTemplate: 'gs://sg360/220520/Airas/ab/ab_Idarkgrey_{nnn}.png',
    },
    black: {
      pathTemplate: 'gs://sg360/220520/Airas/ab/ab_Iblack_{nnn}.png',
    },
    navy: {
      pathTemplate: 'gs://sg360/220520/Airas/ab/ab_Inavy_{nnn}.png',
    },
    mint: {
      pathTemplate: 'gs://sg360/220520/Airas/ab/ab_Mmint_{nnn}.png',
    },
    pink: {
      pathTemplate: 'gs://sg360/220520/Airas/ab/ab_Mpink_{nnn}.png',
    },
    stone: {
      pathTemplate: 'gs://sg360/220520/Airas/ab/ab_Mstone_{nnn}.png',
    },
    white: {
      pathTemplate: 'gs://sg360/220520/Airas/ab/ab_Mwhite_{nnn}.png',
    },
    slateblue: {
      pathTemplate: 'gs://sg360/240409/slateblue/ab_Mslateblue_{nnn}.png',
    },
  },
}

export const nose = {
  id: 'nose',
  name: 'Nose',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    none: {
      disabled: true,
    },
    Fclear: {
      pathTemplate: 'gs://sg360/220520/Airas/an/an_Fclear_{nnn}.png',
    },
    clear: {
      pathTemplate: 'gs://sg360/220520/Airas/an/an_Fclear_{nnn}.png',
    },
    grey: {
      pathTemplate: 'gs://sg360/220520/Airas/an/an_Idarkgrey_{nnn}.png',
    },
    black: {
      pathTemplate: 'gs://sg360/220520/Airas/an/an_Iblack_{nnn}.png',
    },
    navy: {
      pathTemplate: 'gs://sg360/220520/Airas/an/an_Inavy_{nnn}.png',
    },
    mint: {
      pathTemplate: 'gs://sg360/220520/Airas/an/an_Mmint_{nnn}.png',
    },
    pink: {
      pathTemplate: 'gs://sg360/220520/Airas/an/an_Mpink_{nnn}.png',
    },
    stone: {
      pathTemplate: 'gs://sg360/220520/Airas/an/an_Mstone_{nnn}.png',
    },
    white: {
      pathTemplate: 'gs://sg360/220520/Airas/an/an_Mwhite_{nnn}.png',
    },
    slateblue: {
      pathTemplate: 'gs://sg360/240409/slateblue/an_Mslateblue_{nnn}.png',
    },
  },
}

export const earsocks = {
  id: 'earsocks',
  name: 'Earsocks',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    Rblue: {
      pathTemplate: 'gs://sg360/220520/Airas/aes/aes_Rblue_{nnn}.png',
    },
    Rgold: {
      pathTemplate: 'gs://sg360/220520/Airas/aes/aes_Rgold_{nnn}.png',
    },
    Rgrey: {
      pathTemplate: 'gs://sg360/220520/Airas/aes/aes_Rgrey_{nnn}.png',
    },
    Rnavy: {
      pathTemplate: 'gs://sg360/220520/Airas/aes/aes_Rnavy_{nnn}.png',
    },
    Rstone: {
      pathTemplate: 'gs://sg360/220520/Airas/aes/aes_Rstone_{nnn}.png',
    },
    Rblack: {
      pathTemplate: 'gs://sg360/220520/Airas/aes/aes_Rblack_{nnn}.png',
    },
    Rmint: {
      pathTemplate: 'gs://sg360/220520/Airas/aes/aes_Rmint_{nnn}.png',
    },
    Rwhite: {
      pathTemplate: 'gs://sg360/220520/Airas/aes/aes_Rwhite_{nnn}.png',
    },
    Rslateblue: {
      pathTemplate: 'gs://sg360/240409/slateblue/aes_Rslateblue_{nnn}.png',
    },
  },
}

export const icons = {
  id: 'icons',
  name: 'Icons',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    Bblack: {
      pathTemplate: 'gs://sg360/220520/Airas/ai/ai_Bblack_{nnn}.png',
    },
    Bblue: {
      pathTemplate: 'gs://sg360/220520/Airas/ai/ai_Bblue_{nnn}.png',
    },
    Bgold: {
      pathTemplate: 'gs://sg360/220520/Airas/ai/ai_Bgold_{nnn}.png',
    },
    Bgunmetal: {
      pathTemplate: 'gs://sg360/220520/Airas/ai/ai_Bgunmetal_{nnn}.png',
    },
    Bpurple: {
      pathTemplate: 'gs://sg360/220520/Airas/ai/ai_Bpurple_{nnn}.png',
    },
    Bred: {
      pathTemplate: 'gs://sg360/220520/Airas/ai/ai_Bred_{nnn}.png',
    },
    Brosegold: {
      pathTemplate: 'gs://sg360/220520/Airas/ai/ai_Brosegold_{nnn}.png',
    },
    Bsilver: {
      pathTemplate: 'gs://sg360/220520/Airas/ai/ai_Bsilver_{nnn}.png',
    },
    Bwhite: {
      pathTemplate: 'gs://sg360/220520/Airas/ai/ai_Bwhite_{nnn}.png',
    },
  },
}

export const lenses = {
  id: 'lens',
  name: 'Lenses',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    clearBF: {
      pathTemplate: 'gs://sg360/260416/airas/bf/ale_BF_8clear_{nnn}.png',
    },
    fireBF: {
      pathTemplate: 'gs://sg360/260416/airas/bf/ale_BF_8fire_{nnn}.png',
    },
    goldBF: {
      pathTemplate: 'gs://sg360/260416/airas/bf/ale_BF_8gold_{nnn}.png',
    },
    greenBF: {
      pathTemplate: 'gs://sg360/260416/airas/bf/ale_BF_8green_{nnn}.png',
    },
    hvblueBF: {
      pathTemplate: 'gs://sg360/260416/airas/bf/ale_BF_8hvblue_{nnn}.png',
    },
    IRhvblueBF: {
      pathTemplate: 'gs://sg360/260416/airas/bf/ale_BF_8IRIShvblue_{nnn}.png',
    },
    IRsmokeBF: {
      pathTemplate: 'gs://sg360/260416/airas/bf/ale_BF_8IRISsmoke_{nnn}.png',
    },
    purpleBF: {
      pathTemplate: 'gs://sg360/260416/airas/bf/ale_BF_8purple_{nnn}.png',
    },
    silverblueBF: {
      pathTemplate: 'gs://sg360/260416/airas/bf/ale_BF_8silverblue_{nnn}.png',
    },
    smokeBF: {
      pathTemplate: 'gs://sg360/260416/airas/bf/ale_BF_8smoke_{nnn}.png',
    },
    clearZF: {
      pathTemplate: 'gs://sg360/260416/airas/zf/ale_ZF_8clear_{nnn}.png',
    },
    fireZF: {
      pathTemplate: 'gs://sg360/260416/airas/zf/ale_ZF_8fire_{nnn}.png',
    },
    goldZF: {
      pathTemplate: 'gs://sg360/260416/airas/zf/ale_ZF_8gold_{nnn}.png',
    },
    greenZF: {
      pathTemplate: 'gs://sg360/260416/airas/zf/ale_ZF_8green_{nnn}.png',
    },
    hvblueZF: {
      pathTemplate: 'gs://sg360/260416/airas/zf/ale_ZF_8hvblue_{nnn}.png',
    },
    IRhvblueZF: {
      pathTemplate: 'gs://sg360/260416/airas/zf/ale_ZF_8IRIShvblue_{nnn}.png',
    },
    IRsmokeZF: {
      pathTemplate: 'gs://sg360/260416/airas/zf/ale_ZF_8IRISsmoke_{nnn}.png',
    },
    purpleZF: {
      pathTemplate: 'gs://sg360/260416/airas/zf/ale_ZF_8purple_{nnn}.png',
    },
    silverblueZF: {
      pathTemplate: 'gs://sg360/260416/airas/zf/ale_ZF_8silverblue_{nnn}.png',
    },
    smokeZF: {
      pathTemplate: 'gs://sg360/260416/airas/zf/ale_ZF_8smoke_{nnn}.png',
    },
    chrome4ZF: {
      pathTemplate: 'gs://sg360/260416/airas/zf/ale_ZF_8chrome4_{nnn}.png',
    },
    chrome4BF: {
      pathTemplate: 'gs://sg360/260416/airas/bf/ale_BF_8chrome4_{nnn}.png',
    },
  },
}

export const iris = {
  id: 'iris',
  name: 'Iris Mask',
  imgproxySettings,
  mobileImgproxySettings,
  isIrisMask: true,
  options: {
    none: {
      disabled: true,
    },
    IRsmokeBF: {
      pathTemplate: 'gs://sg360/260416/airas/bf/ale_BF_8IRISsmoke_overlay_{nnn}.png',
      maxOpacity: 0.7,
    },
    IRsmokeZF: {
      pathTemplate: 'gs://sg360/260416/airas/zf/ale_ZF_8IRISsmoke_overlay_{nnn}.png',
      maxOpacity: 0.7,
    },
    IRhvblueBF: {
      pathTemplate: 'gs://sg360/260416/airas/bf/ale_BF_8IRIShvblue_overlay_{nnn}.png',
      maxOpacity: 0.7,
    },
    IRhvblueZF: {
      pathTemplate: 'gs://sg360/260416/airas/zf/ale_ZF_8IRIShvblue_overlay_{nnn}.png',
      maxOpacity: 0.7,
    },
  },
}

export const reflection = {
  id: 'reflections',
  isReflection: true,
  name: 'Reflections',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    none: {
      disabled: true,
    },
    r5pcBF: {
      pathTemplate: 'gs://sg360/220520/Airas/Cloud Overlay/BF/5/ale_BF_Cloud Overlay 5_{nnn}.png',
    },
    r10pcBF: {
      pathTemplate: 'gs://sg360/220520/Airas/Cloud Overlay/BF/10/ale_BF_Cloud Overlay 10_{nnn}.png',
    },
    r5pcZF: {
      pathTemplate: 'gs://sg360/220520/Airas/Cloud Overlay/ZF/5/ale_ZF_Cloud Overlay 5_{nnn}.png',
    },
    r10pcZF: {
      pathTemplate: 'gs://sg360/220520/Airas/Cloud Overlay/ZF/5/ale_ZF_Cloud Overlay 10_{nnn}.png',
    },
  },
}

function resolveOptions(customisedProduct) {
  const options = {
    frame: stripMatteOrInfinitePrefix(getSKUWithoutPrefix(customisedProduct.frameChoice?.sku)),
    bottom: stripMatteOrInfinitePrefix(getSKUWithoutPrefix(customisedProduct.bottomChoice?.sku) || 'none'),
    nose: stripMatteOrInfinitePrefix(getSKUWithoutPrefix(customisedProduct.noseChoice?.sku) || 'none'),
    icons: getSKUWithoutPrefix(customisedProduct.iconChoice.sku),
    engraving: 'eN',
    earsocks: getSKUWithoutPrefix(customisedProduct.earsocksChoice.sku),
    lens:
      getSKUWithoutPrefix(customisedProduct.lensChoice.skuWithoutLensTech) +
      customisedProduct.frameType.toUpperCase(),
    iris:
      getSKUWithoutPrefix(customisedProduct.lensChoice.skuWithoutLensTech) +
      customisedProduct.frameType.toUpperCase(),
    reflections: 'r5pc' + customisedProduct.frameType.toUpperCase(),
  }

  if (customisedProduct.frameType === 'zf') delete options.bottom
  if (customisedProduct.frameType === 'bf') delete options.nose

  return options
}

function resolveSecondaryOptions(customisedProduct) {
  const options = {
    bottom: stripMatteOrInfinitePrefix(getSKUWithoutPrefix(customisedProduct.bottomChoice?.sku) || 'none'),
    nose: stripMatteOrInfinitePrefix(getSKUWithoutPrefix(customisedProduct.noseChoice?.sku) || 'none'),
  }

  if (customisedProduct.frameType === 'zf') delete options.nose
  if (customisedProduct.frameType === 'bf') delete options.bottom

  return options
}

export default {
  supports360: false,
  layers: [background, frame, earsocks, bottom, nose, icons, lenses, iris, reflection],
  resolveOptions,
  resolveSecondaryOptions,
  resolveOptionsFromSKU,
}
